import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { storageHelper } from 'src/app/misc/storage.misc';
import { jwtTokenIdentifier } from 'src/app/misc/utilities.misc';
import { AuthService } from 'src/app/services/auth.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { MustMatch } from 'src/app/validator/must-match.validator';

@Component({
  selector: 'app-reset-password-form',
  templateUrl: './reset-password-form.component.html',
  styleUrls: ['./reset-password-form.component.scss']
})
export class ResetPasswordFormComponent implements OnInit {
  accessToken!: string;
  uid!: string;

  resetPasswordForm!: FormGroup;

  submitted = false;
  loading = false;
  showPassword = false;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private sweetAlertService: SweetAlertService,
    private formBuilder: FormBuilder,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.uid = this.route.snapshot.queryParamMap.get('uid')!;
    this.accessToken = this.route.snapshot.queryParamMap.get('token')!;

    this.resetPasswordForm = this.formBuilder.group(
      {
        token: ['', Validators.required],
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
            ),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      {
        validator: MustMatch('password', 'confirmPassword'),
      }
    );
    this.listenToAuthEvents();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.resetPasswordForm.controls;
  }

  listenToAuthEvents() {
    this.authService.authSuccessEvent.subscribe((data) => {
      this.submitted = false;
      this.resetForm();
      var userAccessToken = data.token;
      storageHelper.local.store(`${jwtTokenIdentifier}`, userAccessToken);
      this.router.navigateByUrl('/dashboard');
    });

    this.authService.authFailureEvent.subscribe((error: HttpErrorResponse) => {
      this.submitted = false;
      if (
        error.status === 400 ||
        error.status === 404 ||
        error.status === 401
      ) {
        this.sweetAlertService.toastError(
          'Erreur de connexion !',
          5000,
          'Veuillez vérifier vos accès et réessayer'
        );
      } else {
        this.sweetAlertService.toastError(
          'Erreur de connexion !',
          5000,
          'Le service est temporairement indisponible'
        );
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    this.resetPasswordForm.patchValue({ token: this.accessToken });

    if (this.resetPasswordForm.invalid) {
      return;
    }

    const data = {
      token: this.accessToken,
      uid: this.uid,
      new_password: this.resetPasswordForm.value.password,
    };

    this.loading = true;
    this.authService.resetPassword(data).subscribe({
      next: (response: any) => {
        this.loading = false;
        this.sweetAlertService.toastSuccess('Mot de passe modifié !', 3000);
        this.router.navigateByUrl('/auth/signin');
        this.resetForm();
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.sweetAlertService.toastError(
          'Erreur !',
          5000,
          error.error.message ||
          error.error.error ||
          'Le service est temporairement indisponible'
        );
      },
    });
  }

  togglePassword(passwordInput: HTMLInputElement) {
    if (passwordInput.type === 'password') {
      passwordInput.type = 'text';
      this.showPassword = true;
    } else {
      passwordInput.type = 'password';
      this.showPassword = false;
    }
  }

  resetForm() {
    this.resetPasswordForm.reset();
    Object.keys(this.resetPasswordForm.controls).forEach((c) => {
      this.resetPasswordForm.controls[c].setErrors(null);
    });
  }

  onLogin() {
    this.router.navigate(['/auth/signin']);
  }
}
